export default {
	FACEBOOK_ID: process.env.REACT_APP_FACEBOOK_ID,
	FACEBOOK_PIXEL_ID: process.env.REACT_APP_FACEBOOK_PIXEL_ID,
}
